/* eslint-disable */
import React, { useState, useContext, useRef, useEffect } from "react";
import "./index.css";
import MyContext from "../Mycontext";
import AvatarUser from "../../../static/icon/AvatarUser.svg";
import { Image } from "react-bootstrap";
import StreamingDoctaChatBox from "../StreamingDoctaChatBox";
import WaterfallGallery from "../WaterfallGallery";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../providers/AuthProvider";
import Chatting from "../Chatting";
import { useTheme } from "../../../providers/CustomThemeProvider";
import NormalDoctaChatBox from "../NormalDoctaChatBox";

export interface ChatData {
	name: string;
	type: string;
	data: any;
	schedule?: string | null;
	model?: string;
	response_type?: string;
	parsedData?: any;
	imageList?: any;
	return_type?: any;
}

function ChatList({ refreshCallback }: any) {
	const { t, i18n } = useTranslation();
	const { isDarkMode } = useTheme();
	const user = useAuth()?.userInfo;
	console.log("----------user", user);

	const [scrolling, setScrolling] = useState<boolean>(false);

	const scrollBoxRef = useRef<HTMLDivElement>(null);

	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const { selectedChat, current, chatListData } = context;

	return (
		<>
			<div className="chatList scroll-bar-style chatPage" ref={scrollBoxRef}>
				<div className="wrapper">
					<div className="chat">
						{!scrolling &&
							chatListData.map((item: any, index: any) => (
								<>
									{item?.response_type == "img" && item.type == "ai" ? (
										<>
											<WaterfallGallery
												images={item?.parsedData?.img_list}
												initialColumnCount={3}
												item={item}
											/>
										</>
									) : (
										<>
											{item.type == "ai" ? (
												<>
													<NormalDoctaChatBox
														refreshCallback={refreshCallback}
														type={selectedChat?.type || 0}
														scrollBoxRef={scrollBoxRef}
														isStream={false}
														data={item.data}
														showThumb={index >= chatListData?.length - 2}
													/>
												</>
											) : (
												<>
													<div
														className={
															"chatList-item" +
															(!(item.type == "ai") ? " chatList-item-ai" : "")
														}
														key={index}
														id={index.toString()}
													>
														{/* <div className="chatList-item-img">
															<Image src={AvatarUser} />
														</div> */}
														<div className="chatList-item-user">
															{/* <div className="chatList-item-user-name">
																{item.type == "ai"
																	? i18n.language == "en"
																		? "DOCTA"
																		: "第五维度"
																	: user?.name}
															</div> */}
															<div className="chatList-item-box-wrapper">
																<div className="chatList-item-dialog-box">
																	{item?.imageList?.length > 0 ? (
																		<>
																			{item?.imageList?.map((url: any) => {
																				return (
																					<Image
																						style={{
																							maxWidth: 200,
																							maxHeight: 200,
																						}}
																						src={url}
																					/>
																				);
																			})}
																		</>
																	) : (
																		<>{item.data}</>
																	)}
																</div>
															</div>
														</div>
													</div>
												</>
											)}
										</>
									)}
								</>
							))}

						{current?.length > 0 && (
							<StreamingDoctaChatBox
								refreshCallback={refreshCallback}
								type={selectedChat?.type || 0}
								scrollBoxRef={scrollBoxRef}
								showThumb={true}
							/>
						)}
						<Chatting />
					</div>
				</div>
			</div>
		</>
	);
}

export default ChatList;
